import { Link } from "react-router";
import { PublicPageLayout } from "@/components/PublicPageLayout";

export function NotFoundPage() {
  return (
    <PublicPageLayout>
      <div className="mx-auto max-w-[960px] py-20 sm:py-24">
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#7A808C]">
          404
        </p>
        <h1 className="mt-4 max-w-[700px] text-[42px] font-semibold leading-[0.98] tracking-[-0.04em] text-[#111111] sm:text-[58px]">
          Deze pagina bestaat niet of is verplaatst.
        </h1>
        <p className="mt-6 max-w-[620px] text-[18px] leading-8 text-[#475467]">
          Gebruik de navigatie bovenaan om terug te keren naar de juiste sectie van de
          website, of ga rechtstreeks naar de homepage.
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-full bg-[var(--cs-navy)] px-5 py-3 text-[14px] font-semibold text-white transition-colors hover:bg-[var(--cs-navy-strong)]"
          >
            Naar home
          </Link>
          <Link
            to="/trust"
            className="inline-flex items-center justify-center rounded-full border border-[#D7E0E8] bg-white px-5 py-3 text-[14px] font-semibold text-[#365770] transition-colors hover:border-[#B9C7D1] hover:text-[var(--cs-navy)]"
          >
            Trust Center
          </Link>
        </div>
      </div>
    </PublicPageLayout>
  );
}
